import BusinessProfilePage from './business_profile_page';
import CallsPage           from './calls_page';
import DataSources         from '../data_sources/routes';
import EmptyPage           from '../components/empty_page';
import FacebookConnectPage from './facebook/facebook_page';
import GmbAddressPage      from './google/address_page';
import GmbConnectPage      from './google/connect_page';
import GmbVerifyPage       from './google/verify_page';
import GooglePage          from './google/google_page';
import HostedNumberPage    from './hosted_number_page';
import MessagingPage       from './messaging_page';
import NextdoorPage        from './online_profiles/nextdoor_page';
import PaymentsPage        from './payments_page';
import ProviderPage        from './provider_page';
import renderPage          from '../components/render_page';
import Tab                 from './tab';
import TeamPage            from './team_page';
import TripAdvisorPage     from './online_profiles/tripadvisor_page';
import UserPage            from './user_page';
import WebchatPage         from './webchat_page';
import YelpPage            from './online_profiles/yelp_page';


export default {
  path:         '/:businessID/settings',
  component:    renderPage(EmptyPage),
  onlyTab:      true,
  name:         'Settings',
  tabComponent: {
    component: Tab,
    name:      'settings'
  },
  routes: [
    {
      path:         'business_profile',
      name:         'BusinessProfile',
      component:    renderPage(BusinessProfilePage),
      tabComponent: {
        component: Tab,
        name:      'settings'
      },
      routes: [
        {
          name:         'Google',
          path:         'google',
          component:    renderPage(GooglePage),
          tabComponent: {
            component: Tab,
            name:      'settings'
          },
          routes: [
            {
              name:         'GoogleMyBusinessConnect',
              path:         'connect',
              component:    renderPage(GmbConnectPage),
              tabComponent: {
                component: Tab,
                name:      'settings'
              }
            },
            {
              name:         'GoogleMyBusinessVerify',
              path:         'verify',
              component:    renderPage(GmbVerifyPage),
              tabComponent: {
                component: Tab,
                name:      'settings'
              }
            },
            {
              name:         'GoogleMyBusinessAddress',
              path:         'address',
              component:    renderPage(GmbAddressPage),
              tabComponent: {
                component: Tab,
                name:      'settings'
              }
            }
          ]
        },
        {
          name:         'FacebookPage',
          path:         'facebook',
          component:    renderPage(FacebookConnectPage),
          tabComponent: {
            component: Tab,
            name:      'settings'
          }
        },
        {
          name:         'NextPage',
          path:         'nextdoor',
          component:    renderPage(NextdoorPage),
          tabComponent: {
            component: Tab,
            name:      'settings'
          }
        },
        {
          name:         'TripAdvisorPage',
          path:         'tripadvisor',
          component:    renderPage(TripAdvisorPage),
          tabComponent: {
            component: Tab,
            name:      'settings'
          }
        },
        {
          name:         'YelpPage',
          path:         'yelp',
          component:    renderPage(YelpPage),
          tabComponent: {
            component: Tab,
            name:      'settings'
          }
        }
      ]
    },
    {
      path:         'team',
      name:         'ManageTeam',
      component:    renderPage(TeamPage),
      tabComponent: {
        component: Tab,
        name:      'settings'
      },
      routes: [
        {
          path:         ':userID',
          name:         'ViewUser',
          component:    renderPage(UserPage),
          tabComponent: {
            component: Tab,
            name:      'settings'
          }
        }
      ]
    },
    {
      path:         'invite',
      name:         'InviteUser',
      component:    renderPage(ProviderPage),
      tabComponent: {
        component: Tab,
        name:      'settings'
      },
      routes: [
        {
          path:         ':providerID',
          component:    renderPage(ProviderPage),
          tabComponent: {
            component: Tab,
            name:      'settings'
          }
        }
      ]
    },
    {
      path:         'messaging',
      name:         'SettingsMessaging',
      component:    renderPage(MessagingPage),
      tabComponent: {
        component: Tab,
        name:      'settings'
      },
      routes: [
        {
          path:         'hosted_number',
          name:         'HostedNumber',
          component:    renderPage(HostedNumberPage),
          tabComponent: {
            component: Tab,
            name:      'settings'
          }
        }
      ]
    },
    {
      path:         'calls',
      name:         'SettingsCalls',
      component:    renderPage(CallsPage),
      tabComponent: {
        component: Tab,
        name:      'settings'
      }
    },
    {
      path:         'webchat',
      name:         'WebChat',
      component:    renderPage(WebchatPage),
      tabComponent: {
        component: Tab,
        name:      'settings'
      }
    },
    {
      path:     'invoices',
      redirect: 'payments'
    },
    {
      path:         'payments',
      name:         'PaymentsSettings',
      component:    renderPage(PaymentsPage),
      tabComponent: {
        component: Tab,
        name:      'settings'
      }
    },
    DataSources
  ]
};
